import React from 'react';
import { TableOptions, usePagination, useTable } from 'react-table';
import Loader from '../loader';
import NoDataShown from '../noResult';
import { CurrencyAmount } from 'src/containers/currency';

interface IProps {
  loading?: boolean;
  tableData: any[];
  tableColumn: any;
  getSummaryValuesData: any;
}

interface MyTableOptions<D extends object> extends TableOptions<D> {
  autoResetPage?: boolean;
}

const ScrollTable: React.FC<IProps> = ({
  loading,
  tableData,
  tableColumn,
  getSummaryValuesData,
}) => {
  const data = React.useMemo(() => (tableData ? tableData : []), [tableData]);
  const columns = React.useMemo(() => tableColumn, []);
  const {
    headerGroups,
    getTableBodyProps,
    page,
    prepareRow,
    getTableProps,
  }: any = useTable(
    {
      data,
      columns,
      autoResetPage: false,
      initialState: {
        pageSize: data.length,
      },
    } as MyTableOptions<any>,
    usePagination
  );

  const getSummaryValues = (i: number) => {
    return getSummaryValuesData[i] ? getSummaryValuesData[i]?.total : null;
  };

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <>
          <div className="w-full">
            <div className="mt-5 rounded-xl border border-border-color-dark overflow-x-hidden relative w-full max-h-[70vh]">
              <table
                {...getTableProps()}
                className="w-full text-left text-text-black"
              >
                <thead
                  className="font-semibold text-black
                sticky top-0 bg-pure-white
                border-solid border-0 border-b-[1px] border-border-color-dark"
                >
                  {headerGroups.map((headerGroup: any, i: number) => (
                    <tr {...headerGroup.getHeaderGroupProps()} key={i}>
                      {headerGroup.headers.map((column: any, idx: number) => (
                        <th
                          {...column.getHeaderProps()}
                          key={idx}
                          scope="col"
                          className="py-3 px-4 text-sm whitespace-nowrap"
                        >
                          {/* {column.render('Header')} */}
                          <div className="flex items-center">
                            <span>{column.render('Header')}</span>
                            <span className="ml-2"></span>
                          </div>
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                  {page?.length ? (
                    <>
                      {page.map((row: any, i: number) => {
                        prepareRow(row);
                        return (
                          <tr
                            {...row.getRowProps()}
                            key={i}
                            className="bg-white  border-b border-border-color-dark hover:bg-light-grey dark:hover:bg-light-grey dark:hover:bg-opacity-20 transition-all duration-700 ease-out cursor-pointer  text-base"
                          >
                            {row.cells.map((cell: any, idx: number) => {
                              return (
                                <td
                                  {...cell.getCellProps()}
                                  key={idx}
                                  className="py-3 px-4 "
                                >
                                  {cell?.render('Cell')?.props?.value?.length >
                                  12
                                    ? `${cell
                                        ?.render('Cell')
                                        ?.props?.value?.slice(0, 10)}..`
                                    : cell?.render('Cell')?.props?.value ||
                                      cell?.render('Cell')}
                                </td>
                              );
                            })}
                          </tr>
                        );
                      })}
                    </>
                  ) : (
                    <tr>
                      <td colSpan={headerGroups[0]?.headers.length}>
                        <NoDataShown />
                      </td>
                    </tr>
                  )}
                </tbody>
                <thead
                  className="font-semibold text-black
                sticky bottom-0 bg-pure-white
                border-solid border-0 border-b-[1px] border-border-color-dark"
                >
                  {headerGroups.map((headerGroup: any, i: number) => (
                    <tr {...headerGroup.getHeaderGroupProps()} key={i}>
                      {headerGroup.headers.map((_: any, idx: number) => (
                        <th
                          key={idx}
                          scope="col"
                          className="py-3 px-4 text-sm whitespace-nowrap"
                        >
                          <div className="flex items-center">
                            <span className="ml-2">
                              {getSummaryValues(idx)
                                ? getSummaryValues(idx) === 'Total'
                                  ? `${getSummaryValues(idx)}`
                                  : <CurrencyAmount amount={getSummaryValues(idx)}/>
                                : null}
                            </span>
                          </div>
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>
              </table>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default React.memo(ScrollTable);
